import moment from 'moment'

const toTable = (member) => {
  return {
    id: member.id,
    user: member.user,
    role: member.role,
    status:  member.is_active ? 'active' : 'inactive',
    joined: moment(member.created_at).unix(),
    relations: {
      modules: member.modules,
      groups: member.groups
    }
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  view (state) {
    return (view) => {
      return state.views[view].ids.map((id) => state.views[view].index[id]).map(toTable)
    }
  },

  unsavedChanges (state) {
    const current = state.current
    const formFields = state.forms.update.fields
    let unsaved = false

    if (formFields.role && current.role !== formFields.role) {
      unsaved = true
    }

    if (formFields.active !== null && Number(current.is_active) !== Number(formFields.active)) {
      unsaved = true
    }

    return unsaved
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/members/getters.js